import React from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../assets/main/groups/main-table/array.svg';
import {Link, NavLink} from "react-router-dom";
import {useAppSelector} from "common/hook";
import {getCabinetData} from "entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {ALL_TESTS, TESTS} from "entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";

export const TestsCart = () => {
    // const cabinetData = useAppSelector(getCabinetData);
    const cabinetData = useAppSelector(getCabinetData);

    if (!cabinetData?.tests) {
        return null;
    }

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{TESTS}</p>
                </div>
                {cabinetData.tests && <span className="sub-data">{cabinetData.tests.count}</span>}
            </div>
            <div className="info-card-content">
                {cabinetData.tests.items && cabinetData.tests.items.length > 0 ? (
                    cabinetData.tests.items.map((test) => (
                        <div className="row" key={test.id}>
                            <p>
                                <NavLink to={`/test/${test?.id}`}>{test.title}</NavLink>
                            </p>
                            <div className="students-number">
                                <p>Прошли тест</p>
                                {test.avatars.map((avatarPath, i) => (
                                    <div className="avatar" key={i}>
                                        <img src={avatarPath.key} alt=""/>
                                    </div>
                                ))}
                                <span className="num">{test.passedCount}</span>
                            </div>
                        </div>
                    ))
                ) : (
                        <NothingYetMessage/>
                )}
                {cabinetData && cabinetData.tests && cabinetData.tests.items && cabinetData.tests.items.length > 0 && (
                    <div className='block-arrow-link'>
                        <Link to="/test" className="arrow-link">
                            {ALL_TESTS}
                            <ArrayIcon className="arrow"/>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};








